// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__4dLAO","title":"Images90_title__1PmPt","images":"Images90_images__12JCn"};